import { useState } from "react";
import axios from "axios";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EditCustomerForm = ({ customer, onSuccess, onDelete }) => {
  const [name, setName] = useState(customer?.name || '');
  const [email, setEmail] = useState(customer?.email || '');
  const [phone, setPhone] = useState(customer?.phone || '');
  const [address, setAddress] = useState(customer?.address || '');
  const [city, setCity] = useState(customer?.city || '');
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const token = localStorage.getItem("token");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.put(
        `${API}/customers/${customer.id}`,
        { name, email, phone, address, city },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onSuccess(res.data.customer);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to update customer");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm(`Are you sure you want to delete customer "${customer.name}"?`)) {
      return;
    }
    setDeleteLoading(true);
    try {
      await axios.delete(
        `${API}/customers/${customer.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onDelete(customer.id);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to delete customer");
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label className="text-xs uppercase tracking-widest">Name</Label>
        <Input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="h-10"
          required
          data-testid="edit-customer-name"
        />
      </div>
      <div className="space-y-2">
        <Label className="text-xs uppercase tracking-widest">Email</Label>
        <Input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="h-10"
          required
          data-testid="edit-customer-email"
        />
      </div>
      <div className="space-y-2">
        <Label className="text-xs uppercase tracking-widest">Phone</Label>
        <Input
          type="text"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className="h-10"
          data-testid="edit-customer-phone"
        />
      </div>
      <div className="space-y-2">
        <Label className="text-xs uppercase tracking-widest">Address</Label>
        <Input
          type="text"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          className="h-10"
          data-testid="edit-customer-address"
        />
      </div>
      <div className="space-y-2">
        <Label className="text-xs uppercase tracking-widest">City</Label>
        <Input
          type="text"
          value={city}
          onChange={(e) => setCity(e.target.value)}
          className="h-10"
          data-testid="edit-customer-city"
        />
      </div>
      <div className="flex gap-2 pt-2">
        <Button
          type="submit"
          disabled={loading}
          className="flex-1 h-10 bg-blue-500 hover:bg-blue-600 text-white font-bold uppercase tracking-widest"
          data-testid="save-customer-btn"
        >
          {loading ? "Saving..." : "Save Changes"}
        </Button>
        <Button
          type="button"
          variant="destructive"
          disabled={deleteLoading}
          onClick={handleDelete}
          className="h-10 px-4"
          data-testid="delete-customer-btn"
        >
          {deleteLoading ? "..." : <Trash2 className="w-4 h-4" />}
        </Button>
      </div>
    </form>
  );
};

export default EditCustomerForm;
